<template>
  <div class="flex items-center gap-2">
    <span class="text-xs text-gray-500 hidden md:inline">货币</span>
    <el-select v-model="cur" size="small" class="w-28" @change="onChange">
      <el-option v-for="c in codes" :key="c" :value="c" :label="labels[c]" />
    </el-select>
    <span class="text-xs text-gray-400 hidden lg:inline">{{ rateToString }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useCurrency } from '@/composables/useCurrency'

const { code, setCurrency, rates, rateToString } = useCurrency()

const labels = {
  CNY: 'CNY（¥）',
  USD: 'USD（$）',
  EUR: 'EUR（€）',
  GBP: 'GBP（£）',
  JPY: 'JPY（¥）',
  HKD: 'HKD（HK$）',
  AUD: 'AUD（A$）',
  CAD: 'CAD（C$）',
  SGD: 'SGD（S$）',
  KRW: 'KRW（₩）'
}

const codes = computed(() => Object.keys(rates.value))
const cur = computed({
  get: () => code.value,
  set: (v) => setCurrency(v)
})

const onChange = () => {}
</script>
